import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { VerticalNavigationContext } from './vertical-navigation-context';

import { MotifIcon } from '../icon/icon';
import { MotifIconButton } from '../button/icon-button/icon-button';

import { navigationIcMenu24px } from '../../assets/icons';

const MotifVerticalNavigationHeaderButton = ({ onClick }) => (
  <div className="motif-header-vertical-navigation-open-button" data-motif-vertical-navigation-header-button>
    <MotifIconButton aria-label="Click to open vertical-navigation menu" type="button" onClick={onClick}>
      <MotifIcon src={navigationIcMenu24px} />
    </MotifIconButton>
  </div>
);

MotifVerticalNavigationHeaderButton.defaultProps = {
  onClick: () => null
};

MotifVerticalNavigationHeaderButton.propTypes = {
  onClick: PropTypes.func
};

/**
 * @typedef Props
 * @prop {React.ReactNode} children
 * @prop {string} [className]
 * @prop {string} [ariaLabel]
 * @prop {boolean} [collapse]
 */
/**
 * @param {Props} props
 */
const MotifVerticalNavigation = ({ ariaLabel = 'VerticalNavigation menu bar', children, className = '', collapse = false }) => {
  const classes = classNames({
    'motif-vertical-navigation': true,
    'motif-vertical-navigation-expanded-width': !collapse,
    'motif-vertical-navigation-collapsed': collapse,
    [className]: true
  });

  return (
    <VerticalNavigationContext.Provider value={{ collapse, rootClassName: className }}>
      <nav className={classes} aria-label={ariaLabel} data-motif-vertical-navigation>
        {children}
      </nav>
    </VerticalNavigationContext.Provider>
  );
};

MotifVerticalNavigation.propTypes = {
  ariaLabel: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  collapse: PropTypes.bool
};

export { MotifVerticalNavigation, MotifVerticalNavigationHeaderButton };
